import packageJson from '../../package.json';
import { VERSION_HEADER_KEY } from '../constants/config';
import { getCookieHelpers } from './cookie';

export class HttpError extends Error {
    status: number;
    statusText: string;

    constructor(status: number, statusText: string) {
        super(`HTTP ${status} ${statusText}`);
        this.name = 'HttpError';
        this.status = status;
        this.statusText = statusText;
    }
}

export const getHeaders = () => {
    const { deviceid, clientId, apiKey, ixiSrc, uuid, appVersion, authorization, token } =
        getCookieHelpers().getAllCookies();
    const customHeaders: Record<string, string> = {};

    customHeaders.apikey = apiKey as string;
    customHeaders.clientid = clientId as string;
    customHeaders.ixisrc = ixiSrc as string;

    if (deviceid) customHeaders.deviceid = deviceid as string;
    if (appVersion) customHeaders.appVersion = appVersion as string;
    if (uuid) customHeaders.uuid = uuid as string;
    if (authorization) customHeaders.authorization = authorization as string;
    if (token) customHeaders.token = token as string;

    return customHeaders;
};

export const fetch = async (url: string, options?: RequestInit) => {
    const originalFetch = window.fetch;
    const headers: Record<string, string> = {
        'Content-Type': 'application/json',
        [VERSION_HEADER_KEY]: packageJson.version,
        ...getHeaders(),
        ...(options?.headers as Record<string, string> | undefined),
    };

    if (headers['Content-Type'] === 'multipart/form-data') {
        delete headers['Content-Type'];
    }

    const fetchOptions: RequestInit = { ...options, headers };

    const response = await originalFetch(url, fetchOptions);
    if (!response.ok) {
        throw new HttpError(response.status, response.statusText);
    }
    const data = await response.json();
    return data;
};

export const get = async (url: string, options?: RequestInit) => fetch(url, { ...options, method: 'GET' });

export const post = async (url: string, options?: RequestInit) => fetch(url, { ...options, method: 'POST' });
